import A from './A';
import Svg from './Svg';

const LogoACV = ({ path, width = 75, height = 38, poweredBy, ...props }) => (
  <A href={path} isPlaceholder>
    <Svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 75 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Go to homepage"
    >
      <path
        d="M39.3062 26.8468C36.4905 26.8468 34.4941 24.5492 34.847 21.7148C35.1998 18.8805 37.769 16.5829 40.5848 16.5829C42.2061 16.5829 43.5552 17.3452 44.341 18.5322L49.4867 13.3133C47.6017 11.0445 44.7307 9.63184 41.3563 9.63184C34.7758 9.63184 28.7734 15.0014 27.9484 21.6258C27.1235 28.2496 31.7891 33.6199 38.369 33.6199C41.7576 33.6199 44.9915 32.1946 47.4455 29.9081L42.8864 25.5218C41.879 26.3437 40.6202 26.8468 39.3062 26.8468Z"
        fill="url(#paint0_linear_231_3456)"
      />
      <path
        d="M65.7528 5.26172H75L57.7996 32.5682H48.553L65.7528 5.26172Z"
        fill="url(#paint1_linear_231_3456)"
      />
      <path
        d="M27.0716 23.228C27.0681 22.6731 27.1007 22.1097 27.1717 21.54C27.2633 20.8029 27.4159 20.0762 27.6268 19.365L26.5952 11.8135L20.7076 21.163L21.1819 24.6154H18.521L15.4761 29.4623H21.8422L22.2653 32.5693L29.4293 32.5684L29.0481 29.783C27.739 27.8996 27.0581 25.6419 27.0716 23.228Z"
        fill="url(#paint2_linear_231_3456)"
      />
      <path
        d="M17.1998 10.6929H26.4469L9.24703 38.0002H0L17.1998 10.6929Z"
        fill="url(#paint3_linear_231_3456)"
      />
      <path
        d="M52.6843 10.6929H47.4251C48.5581 11.3438 49.5762 12.2414 50.5205 13.3128L46.4327 17.4505L48.3599 31.5565L54.2469 22.2118L52.6843 10.6929Z"
        fill="url(#paint4_linear_231_3456)"
      />
      <path
        visibility={poweredBy ? 'visible' : 'hidden'}
        d="M11.6495 5.85816L11.3794 7.39093H10.5L11.2593 3.04059L12.79 3.04356C13.2622 3.04356 13.6334 3.17403 13.9035 3.43497C14.1736 3.69591 14.2917 4.03653 14.2576 4.45683C14.2256 4.88312 14.0466 5.22373 13.7204 5.47869C13.3963 5.73364 12.9821 5.86113 12.4778 5.86113L11.6495 5.85816ZM11.7726 5.13208L12.5049 5.13807C12.741 5.13807 12.9371 5.07731 13.0931 4.9558C13.2492 4.83429 13.3423 4.66995 13.3722 4.46282C13.4023 4.25564 13.3682 4.09033 13.2702 3.96681C13.1742 3.84334 13.0311 3.7776 12.841 3.7696L12.0127 3.76663L11.7726 5.13208ZM16.6823 7.45068C16.3922 7.44469 16.1361 7.37699 15.914 7.24752C15.6939 7.11605 15.5188 6.92779 15.3887 6.68281C15.2607 6.43581 15.1866 6.15293 15.1667 5.83425C15.1446 5.50758 15.1796 5.159 15.2717 4.78849C15.3637 4.41797 15.5118 4.0923 15.7159 3.81143C15.92 3.5306 16.1591 3.32045 16.4332 3.18102C16.7093 3.04159 17.0075 2.97485 17.3276 2.98084C17.6217 2.98678 17.8789 3.0565 18.099 3.18998C18.3191 3.32146 18.4921 3.51168 18.6182 3.76064C18.7442 4.00764 18.8163 4.28851 18.8343 4.60325C18.8543 4.95384 18.8163 5.31434 18.7202 5.68486C18.6242 6.05533 18.4751 6.37606 18.273 6.64697C18.0709 6.91783 17.8338 7.12103 17.5617 7.25648C17.2916 7.39193 16.9985 7.45667 16.6823 7.45068ZM17.9279 5.09624L17.9519 4.81239C17.9719 4.45783 17.9239 4.18894 17.8078 4.00567C17.6938 3.8224 17.5197 3.72681 17.2856 3.71881C16.9194 3.70688 16.6283 3.86821 16.4122 4.20288C16.1981 4.53751 16.077 5.00559 16.049 5.60714C16.029 5.95974 16.0761 6.23165 16.1901 6.42287C16.3042 6.61209 16.4812 6.71069 16.7213 6.71865C17.0355 6.73259 17.2956 6.61108 17.5017 6.35412C17.7078 6.09519 17.8428 5.72966 17.9069 5.25757L17.9279 5.09624ZM23.1467 6.12706L24.2003 3.04059H25.0976L23.4739 7.39093H22.5885L22.3574 4.49267L21.2139 7.39093H20.3285L20.0704 3.04059H20.9288L21.0158 6.11211L22.1923 3.04059H22.9397L23.1467 6.12706ZM28.3026 5.50557H26.6279L26.4238 6.67083H28.3927L28.2666 7.39093H25.4184L26.1777 3.04059H29.02L28.8909 3.76663H26.931L26.748 4.80343H28.4287L28.3026 5.50557ZM31.2255 5.79837H30.5112L30.2321 7.39093H29.3527L30.112 3.04059L31.5587 3.04356C32.0429 3.04356 32.415 3.15711 32.6752 3.38418C32.9373 3.61124 33.0533 3.92699 33.0233 4.33134C32.9813 4.92892 32.6612 5.34424 32.0629 5.57729L32.6782 7.34311V7.39093H31.7417L31.2255 5.79837ZM30.6373 5.07233L31.2915 5.07832C31.5237 5.07434 31.7147 5.01258 31.8648 4.89308C32.0169 4.77157 32.1079 4.60723 32.1379 4.40005C32.166 4.20686 32.1349 4.05545 32.0449 3.94592C31.9549 3.83634 31.8118 3.7776 31.6157 3.7696L30.8653 3.76663L30.6373 5.07233ZM36.6216 5.50557H34.9467L34.7427 6.67083H36.7116L36.5856 7.39093H33.7372L34.4965 3.04059H37.3386L37.21 3.76663H35.2499L35.0668 4.80343H36.7477L36.6216 5.50557ZM37.6714 7.39093L38.431 3.04059L39.6854 3.04356C39.9795 3.04955 40.2438 3.11629 40.4778 3.24374C40.7141 3.36923 40.905 3.55049 41.0512 3.78756C41.197 4.02459 41.2853 4.29152 41.3151 4.5883C41.3314 4.76161 41.3292 4.93889 41.309 5.12015L41.2883 5.2785C41.2001 5.9159 40.9481 6.42781 40.5318 6.81428C40.1178 7.1987 39.6142 7.39093 39.0219 7.39093H37.6714ZM39.1844 3.76663L38.6769 6.67083L39.043 6.67385C39.4474 6.67385 39.7714 6.52642 40.0155 6.23165C40.2618 5.93684 40.4028 5.49162 40.4388 4.89605L40.4449 4.80042C40.4506 4.47178 40.3878 4.2198 40.2557 4.04453C40.1235 3.86921 39.9264 3.7776 39.6643 3.7696L39.1844 3.76663ZM44.1957 7.39093L44.9549 3.04059L46.3177 3.04356C46.8239 3.04557 47.2041 3.14815 47.4579 3.35131C47.7121 3.55451 47.8272 3.84032 47.803 4.20883C47.7753 4.64906 47.5203 4.97075 47.0377 5.17391C47.212 5.2337 47.3468 5.34621 47.443 5.51155C47.5391 5.67489 47.58 5.86813 47.5659 6.09122C47.5383 6.50155 47.3758 6.82123 47.0799 7.05031C46.7857 7.27737 46.3835 7.39093 45.8734 7.39093H44.1957ZM45.408 5.49661L45.2012 6.67083L45.8944 6.67385C46.1105 6.67385 46.2913 6.62105 46.4376 6.51549C46.5838 6.40793 46.6707 6.26351 46.6988 6.08225C46.7269 5.90296 46.7019 5.76353 46.6237 5.66392C46.5478 5.56234 46.4187 5.50758 46.2365 5.49962L45.408 5.49661ZM45.516 4.86318L46.1135 4.86917C46.3357 4.86519 46.5166 4.8134 46.6566 4.71379C46.7989 4.61418 46.8836 4.47575 46.9117 4.29847C46.9618 3.94789 46.7769 3.77161 46.3568 3.7696L45.7083 3.76663L45.516 4.86318ZM50.2701 4.99466L51.4915 3.04059H52.5L50.591 5.86113L50.3267 7.39093H49.4323L49.7177 5.76253L48.8111 3.04356L49.7388 3.04059L50.2701 4.99466Z"
        fill="#727374"
      />
      <defs>
        <linearGradient
          id="paint0_linear_231_3456"
          x1="41.2716"
          y1="33.2977"
          x2="37.2452"
          y2="10.1633"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F26723" />
          <stop offset="0.3315" stopColor="#E35323" />
          <stop offset="0.9971" stopColor="#C61621" />
          <stop offset="1" stopColor="#C61521" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_231_3456"
          x1="61.7764"
          y1="32.5685"
          x2="61.7764"
          y2="5.26172"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F26723" />
          <stop offset="0.3315" stopColor="#E35323" />
          <stop offset="0.9971" stopColor="#C61621" />
          <stop offset="1" stopColor="#C61521" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_231_3456"
          x1="21.3905"
          y1="32.8321"
          x2="31.7077"
          y2="14.7268"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F26723" />
          <stop offset="0.3315" stopColor="#E35323" />
          <stop offset="0.9971" stopColor="#C61621" />
          <stop offset="1" stopColor="#C61521" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_231_3456"
          x1="13.2235"
          y1="37.9999"
          x2="13.2235"
          y2="10.6931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F26723" />
          <stop offset="0.3315" stopColor="#E35323" />
          <stop offset="0.9971" stopColor="#C61621" />
          <stop offset="1" stopColor="#C61521" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_231_3456"
          x1="43.5904"
          y1="28.839"
          x2="53.625"
          y2="11.2293"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F26723" />
          <stop offset="0.3315" stopColor="#E35323" />
          <stop offset="0.9971" stopColor="#C61621" />
          <stop offset="1" stopColor="#C61521" />
        </linearGradient>
      </defs>
    </Svg>
  </A>
);

export default LogoACV;
